import { render } from "./AutoSuggestions.vue?vue&type=template&id=33b75a42"
import script from "./AutoSuggestions.vue?vue&type=script&lang=js"
export * from "./AutoSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__